<app-modal-header [title]="title"></app-modal-header>
<ion-content class="container" *ngIf="!isLoading">
  <ion-grid [formGroup]="formGroup">
    <ion-row>
      <ion-col class="odometer-reading">
        <ion-item lines="none">
          <ion-col size="12">
            <ion-label mode="ios" position="stacked">Project</ion-label>
            <ion-label class="projectLabel" (click)="openProjectModal()"
              >{{ selectedProject?.Name }}<span> <ion-icon id="projectTask10" name="caret-down"></ion-icon> </span
            ></ion-label>
          </ion-col>
        </ion-item>
        <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.project)">{{ error }}</ion-note>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="odometer-reading">
        <ion-item lines="none">
          <ion-label mode="ios" position="stacked">Starting Odometer Reading</ion-label>
          <ion-input formControlName="startValue" min="0" type="number" rows="4"></ion-input>
          <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.startValue)">{{ error }}</ion-note>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="hasExistingStartPhoto">
      <ion-col class="odometer-reading">
        <ion-item lines="none">
          <ion-label mode="ios">Start photo captured: ✓</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="shouldShowStartPhotoInput">
      <ion-col class="odometer-reading">
        <ion-item lines="none" class="odometer-photo">
          <ion-label mode="ios" position="stacked">Start Odometer Photo</ion-label>
          <app-image-selector-ui
            #startImagePicker
            [viewOnlyMode]="false"
            [loading]="false"
            [sliderOptions]="sliderOptions"
            [photos]="startOdometerPhotoVm ? [startOdometerPhotoVm] : []"
            [tags]="[]"
            [captureInProgress]="isCapturingStartPhoto"
            [isDisabled]="!!startOdometerPhotoVm"
            [showAddCard]="!startOdometerPhotoVm"
            addLabel="Add"
            [enableEdit]="false"
            [enableRemove]="true"
            (captureRequested)="onStartOdometerPhotoCaptureRequested()"
            (removeRequested)="onStartOdometerPhotoRemoveRequested($event.photo, $event.event)"
            (editRequested)="onStartOdometerPhotoCaptureRequested()">
          </app-image-selector-ui>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="odometer-reading">
        <ion-item lines="none">
          <ion-label mode="ios" position="stacked">Ending Odometer Reading</ion-label>
          <ion-input formControlName="endValue" min="0" type="number" rows="4"></ion-input>
          <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.endValue)">{{ error }}</ion-note>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="hasExistingEndPhoto">
      <ion-col class="odometer-reading">
        <ion-item lines="none">
          <ion-label mode="ios">End photo captured: ✓</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="shouldShowEndPhotoInput">
      <ion-col class="odometer-reading">
        <ion-item lines="none" class="odometer-photo">
          <ion-label mode="ios" position="stacked">End Odometer Photo</ion-label>
          <app-image-selector-ui
            #endImagePicker
            [viewOnlyMode]="false"
            [loading]="false"
            [sliderOptions]="sliderOptions"
            [photos]="endOdometerPhotoVm ? [endOdometerPhotoVm] : []"
            [tags]="[]"
            [captureInProgress]="isCapturingEndPhoto"
            [isDisabled]="!!endOdometerPhotoVm"
            [showAddCard]="!endOdometerPhotoVm"
            addLabel="Add"
            [enableEdit]="false"
            [enableRemove]="true"
            (captureRequested)="onEndOdometerPhotoCaptureRequested()"
            (removeRequested)="onEndOdometerPhotoRemoveRequested($event.photo, $event.event)"
            (editRequested)="onEndOdometerPhotoCaptureRequested()">
          </app-image-selector-ui>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="odometer-reading">
        <ion-item lines="none" disabled>
          <ion-label mode="ios" position="stacked">Mileage</ion-label>
          <ion-input [disabled]="true" class="mileageInput" readonly type="number" rows="4" [value]="mileage"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-row class="form-error">
    <ion-col class="odometer-reading">
      <ion-note color="danger" *ngFor="let error of getFormGroupErrors()">{{ error }}</ion-note>
    </ion-col>
  </ion-row>
  <app-footer-buttons-spacer></app-footer-buttons-spacer>
</ion-content>
<app-footer-buttons
  [rightButton]="{ text: 'Save', disabled: isLoading || !formGroup.valid }"
  [leftButton]="{ icon: 'trash-outline', sizing: 'compact', hidden: isLoading || !odometerReading }"
  (rightButtonClicked)="onSubmit()"
  (leftButtonClicked)="onDelete()"></app-footer-buttons>
